import buttonSwitch from "./buttonSwitch";
import dashboard from "./dashboard";
import event from "./event";
import forms from "./forms";
import header from "./header";
import layout from "./layout";
import project from "./project";
import projectCollection from "./project-collection";
import activityStats from "./activityStats";
import orderedRecords from "./orderedRecords";
import notificationList from "./notificationList";
import navigation from "./navigation";
import ingest from "./ingest";
import gridList from "./gridList";
import category from "./category";
import analytics from "./analytics";
import listEntity from "./listEntity";
import detail from "./detail";

export default `
  ${buttonSwitch}
  ${dashboard}
  ${event}
  ${forms}
  ${header}
  ${layout}
  ${project}
  ${projectCollection}
  ${activityStats}
  ${orderedRecords}
  ${notificationList}
  ${navigation}
  ${ingest}
  ${gridList}
  ${category}
  ${analytics}
  ${listEntity}
  ${detail}
`;
